import Flickity from 'flickity';

export function init() {
	const heroes = Array.from(document.querySelectorAll('.c-hero'));
	heroes.forEach((element) => create(element));
}

function create(element) {
	var options = {
		accessibility: true,
		prevNextButtons: true,
		pageDots: true,
		setGallerySize: false,
		imagesLoaded: true,
		arrowShape:
			'M29.667 20L0 49.998 29.667 80l5.112-5.17L13.84 53.656H100v-7.314H13.84L34.779 25.17z',
	};

	new Flickity(element, options);
}
